import "./loading.scss";

export const Loading: React.FC = () => {
  return (
    <div className="pageContainer">
      <div className="loadingContainer">
        <div className="loadingText">
          <div>
            Gathering the <br /> darts and pieces...
          </div>
        </div>
        <div className="dartboard-loader">
          <div className="ring ring-3"></div>
          <div className="ring ring-2"></div>
          <div className="ring ring-1"></div>
          <div className="center-dot"></div>
        </div>
      </div>
    </div>
  );
};
